import { memo } from 'react';

import cl from './styles.module.scss';

export const FirstCell = memo(() => {
  return (
    <div className={cl.wrap}>
      <div className={cl.row}>Ряд</div>
      <div className={cl.diagonal}></div>
      <div className={cl.cellLabel}>Ячейка в ряду</div>
    </div>
  );
});
